import request from '@/utils/request'


//查询产品
export function getProductList(query) {
  return request({
    url: '/api/product/getProductList',
    method: 'get',
    params: query
  })
}
//通过id查询产品详情
export function getProductById(query) {
  return request({
    url: '/api/product/getProductById',
    method: 'get',
    params: query
  })
}
//查询实验报告
export function getExperimentReportList(query) {
  return request({
    url: '/api/product/getExperimentReportList',
    method: 'get',
    params: query
  })
}
//查询测试报告
export function getTestReportList(query) {
  return request({
    url: '/api/product/getTestReportList',
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/product.js